
import { useTranslation } from 'react-i18next';

export default function AuroraHeroSection() {
  const { t, i18n } = useTranslation();
  
  // 言語に応じてリンクを切り替え
  const detailsLink = i18n.language === 'ja' 
    ? 'https://aurora-card.com/jp/?userRef=DP1121'
    : 'https://aurora-card.com/?userRef=DP1121';
  
  return (
    <section className="relative bg-gradient-to-br from-purple-900 via-gray-900 to-blue-900 py-20 overflow-hidden">
      {/* Background Card Image */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/90 via-gray-900/85 to-blue-900/90"></div>
        <img 
          src="https://static.readdy.ai/image/75eaeb23002452c01ddd137892cf07ae/be240d882f3e3d0798f1829c102bad6a.png"
          alt="Aurora Card"
          className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-auto object-contain opacity-40 mix-blend-lighten"
          style={{ filter: 'blur(1px)' }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center space-y-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white">
            {t('aurora.hero.title')}
          </h1>
          <p className="text-xl md:text-2xl text-purple-200 max-w-3xl mx-auto">
            {t('aurora.hero.subtitle')}
          </p>
          <p className="text-lg text-gray-300 max-w-4xl mx-auto leading-relaxed">
            {t('aurora.hero.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
            <a 
              href="https://app.aurora-card.com/signup?userRef=DP1121"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              {t('aurora.hero.cta.signup')}
            </a>
            <a 
              href={detailsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-700 hover:bg-gray-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              {t('aurora.hero.cta.website')}
            </a>
          </div>
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20 z-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-purple-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
      </div>
    </section>
  );
}
